import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import type { ProductAvailability } from '@packages/modules/src/ProductCard/ProductAvailabilityOverlay/ProductAvailabilityOverlay.types';

export const ProductAvailabilityOverlayFragment = graphql(/* GraphQL */ `
  fragment ProductAvailabilityOverlayFragment on ProductAvailability {
    ... on AvailabilityDescription {
      description
    }
    ... on AvailableVariations {
      variations {
        availability {
          description
        }
        href
        name
      }
    }
  }
`);

export const mapProductCardAvailabilities = (
  maskedData: FragmentType<typeof ProductAvailabilityOverlayFragment>,
): ProductAvailability => {
  const data = getFragmentData(ProductAvailabilityOverlayFragment, maskedData);

  switch (data.__typename) {
    case 'AvailabilityDescription':
      return { alternateText: data.description, values: [] };
    case 'AvailableVariations':
      return {
        values: data.variations.map(({ name, href, availability: { description } }) => ({
          availabilityName: name,
          message: description,
          variationProductUrl: href,
        })),
      };
    default:
      return { values: [] };
  }
};
